import { render, staticRenderFns } from "./EditImagesForm.vue?vue&type=template&id=01c4bd7e&"
import script from "./EditImagesForm.vue?vue&type=script&lang=js&"
export * from "./EditImagesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports